import { shallowRef as f, ref as d, computed as v } from "vue";
const m = Symbol("v-modal-root");
function p(t) {
  return o[t] ? o[t] : _(t);
}
const o = {};
function _(t) {
  const n = f([]), u = d(!1);
  function l(e) {
    n.value = [...n.value, e];
  }
  function i(e) {
    n.value = n.value.filter((s) => s.id !== e.id);
  }
  function a(e) {
    return e.containerId === t;
  }
  const c = v(() => n.value.filter(a)[0] ?? null), r = {
    queue: n,
    isPending: u,
    currentDialog: c,
    push: l,
    dispose: i
  };
  return o[t] = r, r;
}
export {
  m as DefaultModalOutlet,
  p as useModalOutlet
};
